import { useCallback, useEffect, useState } from 'react';
import { inventory as api } from '../api-client/index';
export function useInventory() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await api.list();
            setItems(data);
        }
        catch (e) {
            setError('Failed to load inventory');
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        void load();
    }, [load]);
    const create = useCallback(async (quantityBags, status, arrivalDate) => {
        const item = await api.create(quantityBags, status, arrivalDate ?? null);
        setItems(prev => [item, ...prev]);
        return item;
    }, []);
    const update = useCallback(async (item) => {
        await api.update(item);
        setItems(prev => prev.map(i => (i.id === item.id ? item : i)));
    }, []);
    const remove = useCallback(async (id) => {
        await api.remove(id);
        setItems(prev => prev.filter(i => i.id !== id));
    }, []);
    const arrive = useCallback(async (id, arrivalDate) => {
        const updated = await api.arrive(id, arrivalDate);
        if (!updated)
            return;
        setItems(prev => prev.map(i => (i.id === id ? updated : i)));
    }, []);
    return { items, loading, error, load, create, update, remove, arrive };
}
